import $ from 'jquery';
import 'what-input';
import Vue from 'vue';
import { instance } from './api/instance.js';
import LazyLoad from "vanilla-lazyload";
import Waypoints from 'waypoints/lib/jquery.waypoints.min.js';
import Fancybox from '@fancyapps/fancybox';
import '@fancyapps/fancybox/dist/jquery.fancybox.css';
import 'swiper/css/swiper.min.css';
import Swiper from 'swiper';
import ExampleComponent from './components/ExampleComponent.vue';
import PostsComponent from './components/PostsComponent.vue';
import CursorComponent from './components/CursorComponent.vue';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import lottie from 'lottie-web';
import videojs from 'video.js';

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
//window.jQuery = $;
//require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';
//$(document).foundation(); // foundation functions

var heroSwiper;

// Use API
Vue.prototype.$http = instance;

// Enable to use Vue.js
var vue = new Vue({
  el: '#app',
  mounted() {
    console.log('Running Vue.js');
    let vm = this;
    if(window.pageYOffset > 150) {
      this.menu_scroll = true;
    }
    this.check_scroll();
  },
  components: {
    'example-component': ExampleComponent,
    'posts-component': PostsComponent,
    'cursor-component': CursorComponent
  },
  data: {
  	menu_active: false,
    name: 'Test',
    menu_scroll: false,
    invertSections: $('[data-inverted-section]'),
    menu_inverted: false,
  },
  methods: {
  	toggle_menu: function() {
  		this.menu_active = !this.menu_active;
    },
    check_scroll: function() {
      let vm = this;
      console.log(vm)
      window.addEventListener('scroll', function(e) {
        if(window.pageYOffset > 150) {
          vm.menu_scroll = true;
        } else {
          vm.menu_scroll = false;
        }
      });
    },
    invertWaypoint(direction, reversed) {
      let firstDir = reversed ? 'up' : 'down';
      let vm = this;
      if(direction == firstDir) {
        vm.menu_inverted = true;
      } else {
        vm.menu_inverted = false;
      }
    },
  },
  watch: {
    menu_active: function(newValue) {
      let vm = this;
      if(newValue === true) {
        $('html').addClass('disable-scroll');
        $(document).click(function(e) {
          if(e.target.id !== 'burger-navigation' && !e.target.closest('.burger-menu')) {
            vm.menu_active = false;
          }
        });
      } else {
        $('html').removeClass('disable-scroll');
      }
    },
    menu_scroll: function(newVal) {
      if(newVal == true) {
        if(typeof heroSwiper !== 'undefined' && heroSwiper.autoplay && heroSwiper.autoplay.running) {
          heroSwiper.autoplay.stop();
          //$('.hero-banner .swiper-slide-active video').trigger('pause');
          $('.hero-banner .swiper-slide-active circle').css({'animation':'none'});
        } else if($('body.single-directors').length) {
          $('.hero-banner .film video').trigger('pause');
        }
      } else {
        if(typeof heroSwiper !== 'undefined' && heroSwiper.autoplay && !heroSwiper.autoplay.running) {
          heroSwiper.autoplay.start();
          //$('.hero-banner .swiper-slide-active video').trigger('play');
          $('.hero-banner .swiper-slide-active circle').css({'animation':''});
        } else if($('body.single-directors').length) {
          $('.hero-banner .film video').trigger('play');
        }
      }
    }
  }
});

if(($('body.single-directors').length) || ($('body.single-post').length)) {
  let heroVid = $('.hero-banner .film video');
  function restartHeroSingle() {
    let currentTime = heroVid[0].currentTime;
    let startTime = heroVid.attr('data-start-time');
    let endTime = parseInt(startTime) + 8;
    if(currentTime >= endTime) {
      heroVid[0].currentTime = startTime;
    }
  }
  var loopHeroSingle = setInterval(restartHeroSingle, 200);
}

// Swiper
if (typeof Swiper !== 'undefined') {
  heroSwiper = new Swiper('.hero-swiper', {
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
    },
    initialSlide: Math.floor(Math.random() * 5),
    preventClicks: false,
    effect: 'fade',
    loop: true,
    simulateTouch: false,
    navigation: {
      nextEl: '.hero-controls .right',
      prevEl: '.hero-controls .left'
    },
    pagination: {
      el: '.hero-pagination',
      type: 'custom',
      renderCustom: function(heroSwiper, current, total) {
        return '<h4>' + current + '/' + total + '</h4>';
      }
    },
    on: {
      init: function() {
        // this.autoplay.stop();
        let heroCircle = $('.hero-banner .swiper-slide-active circle');
        if(heroCircle.length) {
          heroCircle.css({'animation':'none'});
        }
      }
    }
  });
}

let heroCircleGlobal = $('.hero-banner .swiper-slide-active circle');

(function($) {
    $(function() { // Loaded when DOM is ready
        console.log("Running jQuery");

        function logElementEvent(eventName, element) {
          console.log(Date.now(), eventName, element.getAttribute("data-src"));
        }

        var callback_enter = function (element) {
          logElementEvent("🔑 ENTERED", element);
        };
        var callback_exit = function (element) {
          logElementEvent("🚪 EXITED", element);
        };
        var callback_loading = function (element) {
          logElementEvent("⌚ LOADING", element);
        };
        var callback_loaded = function (element) {
          logElementEvent("👍 LOADED", element);
        };
        var callback_finish = function () {
          logElementEvent("✔️ FINISHED", document.documentElement);
        };


        $('.trigger-share').on('click', (e) => {
            let trigger = e.target.dataset.trigger;
            $('.share-box.box-' + trigger).addClass('show');

            setTimeout(() => {
              $('.share-box.box-' + trigger).removeClass('show');
            }, 10000)
        })

      $('.copy-link').on('click', (e) => {
        let trigger = e.target.dataset.trigger;
        let link = e.target.dataset.link;

        $('.link-copied-' + trigger).addClass('show');
        setTimeout(() => {
          $('.link-copied-' + trigger).removeClass('show');
        }, 2000);

        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val(link).select();
        document.execCommand("copy");
        $temp.remove();
      })

        // Replace source for large screens:
        // let allVideos = $('video[data-hd-src');
        // let allFeatured = $('.listed-film img.fallback-image');
        // function replaceSrc(array) {
        //   array.each(function() {
        //     let $hd_src = $(this).attr('data-hd-src');
        //     if($(this).attr('data-src')) {
        //       $(this).attr('data-src', $hd_src);
        //     } else {
        //       $(this).attr('src', $hd_src);
        //     }
        //   });
        // }
        // if(window.matchMedia("(min-width: 1024px)").matches) {
        //   if(allFeatured.length) {
        //     replaceSrc(allFeatured);
        //   }
        //   if(allVideos.length) {
        //     replaceSrc(allVideos);
        //   }
        // }

        var lazyloadImages = new LazyLoad({
          // Assign the callbacks defined above
          elements_selector: '.fallback-image.lazy',
        });

        let lazyloadFilms = new LazyLoad({
          elements_selector: '.lazy-video',
          unobserve_entered: true, // <- Avoid executing the function multiple times
          callback_loaded: function(el) {
            $(el).closest('.listed-film').find('.fallback-image').addClass('ready');
          },
          callback_error: function(el) {
            console.log('error', el);
          },
        });

        // Restart animation on page leave/enter
        document.addEventListener('visibilitychange', function(e) {
          let circles = $('.hero-banner .watch-link circle');
          let state = document.visibilityState;
          if(state == 'hidden') {
            circles.each(function() {
              $(this).css({'animation' : 'none'});
            });
          } else {
            circles.each(function() {
              let js = this;
              setTimeout(function() {
                $(js).css({'animation' : ''});
              }, 100);
            });
          }
        });
        // Animations on slideChange
        heroSwiper.on('slideChange', function(e) {
          let circles = $('.hero-banner .watch-link.circle');
          circles.each(circle => {
            $(circle).css({'animation' : 'none'});
            setTimeout(function() {
              $(circle).css({'animation' : ''});
            }, 300);
          });
        });
        // heroSwiper.on('slideChangeTransitionStart', function() {
        //   let activeVideo = $('.hero-banner .swiper-slide-active video');
        //   activeVideo.trigger('play');
        // });

        // Pause swiper, iframe/video and animation when watching.

         $('[data-fancybox]').fancybox({
          video: {
            tpl:
              '<video preload="none" paused class="fancybox-video video-js" controls controlsList="nodownload" poster="{{poster}}">' +
              '<source src="{{src}}" type="{{format}}" />' +
              'Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!' +
              "</video>",
            format: "",
            autoStart: true
          }
        });

        let closestVid;
        let closestCircle;
        let player;
        let cursor = $('#vue-cursor');
        // Add title to videojs
        // from https://jsbin.com/vobacas/edit?html,css,js,output
        var Component = videojs.getComponent('Component'); // base component
        var videoTitle = videojs.extend(Component, {
          constructor: function(player, options) {
            Component.apply(this, arguments);
            // If a `text` option was passed in, update the text content of
            // the component.
            if (options.text) {
              this.updateTextContent(options.text);
            }
          },
          // The `createEl` function of a component creates its DOM element.
          createEl: function() {
            return videojs.dom.createEl('div', {
              // Prefixing classes of elements within a player with "vjs-"
              // is a convention used in Video.js.
              className: 'vjs-video-title ',
            });
          },
          // This function could be called at any time to update the text
          // contents of the component.
          updateTextContent: function(text) {
            // If no text was provided, default to "Title Unknown"
            if (typeof text !== 'string') {
              text = 'Unknown title';
            }
            // Use Video.js utility DOM methods to manipulate the content
            // of the component's element.

            videojs.dom.emptyEl(this.el());
            videojs.dom.appendContent(this.el(), text);
          }
        });
        // Register the component with Video.js, so it can be used in players.
        videojs.registerComponent('videoTitle', videoTitle);
        $(document).on('afterLoad.fb', function(e, instance, slide) {
          player = videojs(document.querySelector('.fancybox-video'), {
            bigPlayButton: false,
            controlBar: {
              volumePanel: false,
              playToggle: false,
              fullscreenToggle: false,
              remainingTimeDisplay: false,
              audioTrackButton: false,
              progressControl: {
                seekBar: {
                  loadProgressBar: true,
                  mouseTimeDisplay: true,
                  playProgressBar: true,
                },
              },
              pictureInPictureToggle: false,
            },
          });
          player.playsinline('true');
          $('.vjs-progress-control.vjs-control').addClass('videoHover');
          $('.fancybox-button.fancybox-button--close').addClass('videoHover');
          $('.videoHover').on('mouseenter', function(e) {
              cursor.attr('hoverVideo', 'true');
          });
          $('.videoHover').on('mouseleave', function(e) {
              cursor.attr('hoverVideo', 'false');
          });
          player.on('touchstart', function (e) {
            if (e.target.nodeName === 'VIDEO') {
                if (player.paused()) {
                    this.play();
                } else {
                    this.pause();
                }
            }
          });
        });
        $(document).on('afterShow.fb', function(e, instance, slide) {
          if((slide.type === 'video')) {
            let trigger = instance.$trigger[0];
            player.addChild('videoTitle', {
              text: '',
            });
            let titleObj = $('.vjs-video-title');
            titleObj.append("<div><span style='display:inline-block;'>" + trigger.getAttribute('data-video-title') + "</span><span style='display: inline-block; margin-left: 8px;'><a style='color: rgba(255, 255, 255, 0.4); text-decoration:none;' href='" + trigger.getAttribute('data-video-link') + "'>" + trigger.getAttribute('data-video-after') + "</a></span></div>");
            gsap.from('.vjs-video-title span, .vjs-progress-control.vjs-control', {
              opacity: 0,
              y: 15,
              duration: 0.5,
              stagger: {
                amount: 0.15,
              },
              delay: 0.5,
            });
            $(document).on('keyup.custom-fancybox-close', function(e) {
              if (e.key === "Escape") { // escape key maps to keycode `27`
                $.fancybox.destroy();
              }
            });
            // Front page hero banner
            if(heroSwiper.autoplay) {
              closestVid = $(trigger).closest('.film-slide').find('video')[0];
              closestCircle = $(trigger).siblings('svg').find('circle');
              closestCircle.css({'animation-play-state':'paused'});
              heroSwiper.autoplay.stop();
            // Single director hero banner
            } else if ($(trigger).closest('.hero-banner.single-director').length) {
              closestVid = $(trigger).closest('.hero-banner.single-director').find('video')[0];
            // Listing films
            } else {
              closestVid = $(trigger).closest('.listed-film').find('video')[0];
            }
            $(closestVid).trigger('pause');
          }
        });
        $(document).on('beforeClose.fb', function(e, instance, slide) {
          player.off('useractive.videoPause');
          player.off('userinactive.videoPause');
        });
        $(document).on('afterClose.fb', function(e, instance, slide) {
          if(heroSwiper.autoplay) {
            closestCircle.css({'animation-play-state':'running'});
          } else {
            $(closestVid).trigger('play');
          }
          $(document).unbind('keyup.custom-fancybox-close');
        });

       let masthead = $('#masthead');
       let normalToWhiteNavbarTop = $('div[data-invert="false"]').waypoint({
          handler: function(direction) {
            if(direction == 'down') {
              if(!masthead.hasClass('normal-navbar')) {
                masthead.addClass('normal-navbar');
              }
            } else {
              if(masthead.hasClass('normal-navbar')) {
                masthead.removeClass('normal-navbar');
              }
            }
          },
          offset: () => $('#masthead').height(),
       });
       let normalToWhiteNavbarBottom = $('div[data-invert="false"]').waypoint({
        handler: function(direction) {
          if(direction == 'down') {
            if(masthead.hasClass('normal-navbar')) {
              masthead.removeClass('normal-navbar');
            }
          } else {
            if(!masthead.hasClass('normal-navbar')) {
              masthead.addClass('normal-navbar');
            }
          }
        },
        offset: function() {
          return (-this.element.clientHeight + masthead[0].clientHeight);
        }
     });

        let loopVideo;
        function listedFilmPlayState(direction, element, reversed) {
          let firstDir = reversed ? 'up' : 'down';
          let el = element;
          let img = $(el).find('img');
          let video = $(el).find('video');
          let overlay = $(el).find('.overlay');
          let startTime = parseInt(video.attr('data-start-time'));
          let endTime = startTime + 8;

          function restartVideo() {
            if(video[0].currentTime >= endTime) {
              video[0].currentTime = startTime;
            }
          }
          if(direction == firstDir) {
            if(video[0].paused) {
              var playPromise = video[0].play();
              if(playPromise !== undefined) {
                playPromise.then(_ => {
                })
                .catch(error => {
                  setTimeout(function() {
                    if(video.closest('.listed-film').find('img.fallback-image.active').length) {
                      video[0].play();
                    }
                  }, 500);
                });
              }
              overlay.addClass('active');
              img.addClass('active');
              loopVideo = setInterval(restartVideo, 100);
            }
          } else {
            overlay.removeClass('active');
            overlay.removeClass('ready');
            img.removeClass('active');
            if(!video[0].paused) {
              video.trigger('pause');
              clearInterval(loopVideo);
            }
          }
        }
        var filmsBottom = $('.listed-film').waypoint({
          handler: function(direction) {
            console.log("filmsBottom");
            let el = this.element;
            console.log(this.element.clientHeight)
            listedFilmPlayState(direction, el);
          },
          offset: 'bottom-in-view',
        });
        var filmsTop = $('.listed-film').waypoint({
          handler: function(direction) {
            console.log("filmsTop");
            let el = this.element;
            listedFilmPlayState(direction, el, true);
          },
          offset: '-15%'
        });

        // ScrollTrigger.matchMedia({
        //   "(min-width: 640px)": () => {
        //     ScrollTrigger.create({
        //       trigger: ".page-title.directors",
        //       start: () => `bottom bottom-=${$( window ).height() * 0.1}`,
        //       endTrigger: '.gsapped',
        //       end: () => `bottom+=${$( window ).height() * 0.1} bottom`,
        //       pin: true,
        //       pinSpacing: false,
        //     });
        //   },
        // });

        /* Lottie Preload animation */
        let storage = window.sessionStorage;
        function clearPreload() {
          $('body').removeClass('disable-scroll');
          $('#animation-section').addClass('hidden-preloader');
        }
        function initialGsapFunc() {
          let initialGsap = gsap.timeline({delay:0.5});
          initialGsap.from("#burger-wrapper, #logo-wrapper, #socials-wrapper", {
            opacity: 0,
            y: 15,
            duration: 0.5,
            stagger: {
              amount: 0.3,
            }
          });
        }

      if($('#lottie').length && !storage.getItem('page-preload')) {
        $('body').addClass('disable-scroll');
        var animation = lottie.loadAnimation({
          container: document.getElementById('lottie'),
          renderer: 'svg',
          loop: false,
          autoplay: true,
          path: site_vars.theme_url + '/assets/img/thirsty-outline-animation.json'
        });
        animation.setSpeed(1.3);

        let animationCount = 0;
        animation.addEventListener('complete', function() {
          animationCount++;
          if(animationCount == 1) {
            $(document).ready(function(){
              animation.addEventListener('complete', function() {
                clearPreload();
                initialGsapFunc();
                heroSwiper.autoplay.start();
                heroCircleGlobal.css({'animation':''});
                /* Set Localstorage */
                storage.setItem('page-preload', true);
              });
              setTimeout(function() {
                animation.setDirection(-1);
                animation.setSpeed(2.6);
                animation.play();
              }, 300)
            });
          }
        });
      } else {
        clearPreload();
        if(heroCircleGlobal) {
          heroCircleGlobal.css({'animation':''});
        }
      }
    }); // Don't go further.
})( jQuery );
